export const DataQueryParamFrom = 'from';
